// ... existing code ...

export default function AboutSection() {
  return (
    <section id="about" className="py-10 sm:py-16 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center gap-8 sm:gap-12">
        {/* Left: Image with "About" overlay */}
        <div className="w-full md:flex-1 relative">
          <img
            src="https://cdn1.npcdn.net/userfiles/25709/image/img1-beige(1).png"
            alt="About Insglobal"
            className="w-full object-cover"
          />
          <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6">
            <span
              className="text-3xl sm:text-4xl font-bold text-white drop-shadow-lg"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              About
            </span>
          </div>
        </div>

        {/* Right: Text content */}
        <div className="w-full md:flex-1">
          <p className="text-xs tracking-[0.2em] uppercase text-gray-500 mb-3">
            Professional Makeup and Styling
          </p>
          <h2
            className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4 sm:mb-5 leading-snug"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Courses and Services
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Insglobal Creation, formerly known as Lartistry, was established in 2014. We
            specialize in providing comprehensive professional courses with a strong emphasis on
            image makeup, styling, and bridal image design. Our expertise extends across the
            bridal, commercial, and film industries, where we actively contribute and stay aligned
            with current trends and demands.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Our team is dedicated to leveraging its extensive knowledge and skills to deliver
            exceptional training and services. We take pride in offering the highest standards of
            education, ensuring our students receive both practical and theoretical insights.
            Furthermore, all our instructors remain actively involved in makeup and hairstyling
            for various events, with a specialization in designing complete and cohesive image
            solutions.
          </p>
        </div>
      </div>
    </section>
  );
}
